<template>
	<div class='page'>
		
		<Navigation />

		<!-- <div class='hamburger'
			@click='showNav = !showNav'>
			<div class='hamburger__bar'></div>
			<div class='hamburger__bar'></div>
			<div class='hamburger__bar'></div>
		</div> -->

		<div class='external-links'>
			<a  href='https://github.com/stelaseldano'
				title='github'
				class='external-link'>
				<img class='external-link__image' src='../assets/marks/github.png' alt='github profile' />
			</a>
			<a  href='https://dribbble.com/stelaseldano'
				title='dribbble'
				class='external-link'>
				<img class='external-link__image' src='../assets/marks/dribbble.png' alt='dribble profile' />
			</a>
			<a 	href='https://codepen.io/stelaseldano'
				title='codepen'
				class='external-link'>
				<img class='external-link__image' src='../assets/marks/codepen.png' alt='codepen profile' />
			</a>
		</div>

		<h1 class='page__title'>{{ title }}</h1>
		
		<router-view class='page-content'></router-view>

	</div>
</template>

<script>
import Navigation from './Navigation'

export default {
	name: 'Page',

	components: {
		Navigation
	},

	data: () => {
		return {
			title: '',
		}
	},

	created() {
		this.title = this.$route.name;
	},

	updated() {
		this.title = this.$route.name;
		window.scrollTo(0, 0);
	},
}
</script>

<style lang='less'>
@import '../colours';

.page {
	display: grid;
	grid-template-columns: 200px 120px auto 100px;
	grid-template-rows: 60px 120px 50px auto;
	width: 100%;
	max-width: 1400px;
	box-sizing: border-box;
	padding: 30px;
}

.page__title {
	grid-column: 2 / span 1;
	grid-row: 2 / span 1;
	font-size: 120px;
	color: @light-blue;
	font-weight: bold;
	margin: 0;
	font-family: Inconsolata, monospace;
}

// main link look
.link {
	margin: 10px 10px 10px 0;
	color: @pink;

	&:hover {
		font-weight: bold;
	}
}

.external-links {
	display: flex;
	flex-direction: column;
	align-items: center;
	position: fixed;
	right: 50px;
}

.external-link {
	height: 30px;
	display: block;
	margin: 5px;
	transition: all 0.075s ease;

	&:hover {
		transform: scale(1.2);
	}
}

.external-link__image {
	height: 100%;
}

.page-content {
	grid-column: 3 / span 1;
	grid-row: 4 / span 1;
}

.hamburger {
    position: fixed;
    top: calc(~"50vh - 35px");
	left: -30px;
}

.hamburger__bar {
	height: 10px;
	width: 60px;
	background-color: @grey;
    margin: 10px;
}

@media screen and (max-width: 1024px) {

	.page {
		grid-template-columns: 120px 90px auto 100px;
		grid-template-rows: 60px 100px 50px auto;
	}

	.page-content {
		grid-column: 2 / span 2;
		grid-row: 4 / span 1;
	}
}

@media screen and (max-width: 960px) {

	.page {
		grid-template-columns: 50px 90px auto 50px;
		grid-template-rows: 60px 100px 50px auto;
	}

	.page__title {
		grid-column: 2 / span 1;
		font-size: 80px;
	}
}

@media screen and (max-width: 550px) {

	.page {
		grid-template-columns: 1fr;
		grid-template-rows: 30px 60px 20px auto;
	}

	.page__title {
		grid-column: 1 / span 1;
		font-size: 60px;
	}

	.page-content {
		grid-column: 1 / span 1;
		grid-row: 4 / span 1;
	}

	.external-links {
		right: 20px;
		flex-direction: row;
		top: 10px;
	}

	.external-link {
		height: 20px;
		margin: 7px;
	}
}

</style>
